<template>
    <section class="dp-layout moredian-manage">
        <!-- 左侧部门树 -->
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <!-- 右侧内容区 -->
        <section class="dp-right">
            <template v-if="selectedDeptId">
                <!-- 魔点对接配置：紧凑条，减少纵向占用 -->
                <div class="md-config-panel">
                    <div class="md-config-panel__head">
                        <div class="md-config-panel__title">
                            <i class="el-icon-setting" />
                            <span>魔点对接配置</span>
                            <el-tag :type="configForm.IsCallbackSync ? 'success' : 'info'" size="mini" effect="plain">
                                {{ configForm.IsCallbackSync ? '回调已同步' : '回调未同步' }}
                            </el-tag>
                            <el-button type="text" icon="el-icon-link" @click="registerCallback">注册回调</el-button>
                            <span v-if="configForm.CallbackUrl" class="md-config-panel__callback" :title="configForm.CallbackUrl">
                                {{ configForm.CallbackUrl }}
                            </span>
                        </div>
                        <div class="md-config-panel__actions">
                            <template v-if="!isEdit">
                                <el-button type="primary" plain icon="el-icon-edit" @click="toggleEdit">更改配置</el-button>
                            </template>
                            <template v-else>
                                <el-button @click="cancelEdit">取消</el-button>
                                <el-button type="primary" :loading="saveLoading" @click="saveConfig">保存配置</el-button>
                            </template>
                        </div>
                    </div>

                    <div v-if="isEdit" class="md-config-panel__body md-config-panel__body--edit">
                        <el-form :model="configForm" label-width="88px" class="md-config-form">
                            <div class="md-config-grid">
                                <el-form-item label="OrgID">
                                    <el-input v-model="configForm.OrgID" placeholder="机构ID" />
                                </el-form-item>
                                <el-form-item label="APPID">
                                    <el-input v-model="configForm.AppID" placeholder="APPID" />
                                </el-form-item>
                                <el-form-item label="APPKey">
                                    <el-input
                                        v-model="configForm.AppKey"
                                        :class="{ 'password-input': !showAppKey }"
                                        placeholder="APPKey">
                                        <i
                                            slot="suffix"
                                            :class="showAppKey ? 'el-icon-view' : 'el-icon-minus'"
                                            class="md-config-toggle"
                                            @click="showAppKey = !showAppKey" />
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="OrgAuthKey">
                                    <el-input
                                        v-model="configForm.OrgAuthKey"
                                        :class="{ 'password-input': !showOrgAuthKey }"
                                        placeholder="OrgAuthKey">
                                        <i
                                            slot="suffix"
                                            :class="showOrgAuthKey ? 'el-icon-view' : 'el-icon-minus'"
                                            class="md-config-toggle"
                                            @click="showOrgAuthKey = !showOrgAuthKey" />
                                    </el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>

                    <div v-else class="md-config-panel__body md-config-panel__body--view">
                        <div class="md-config-summary">
                            <div class="md-config-summary__item">
                                <span class="md-config-summary__label">OrgID</span>
                                <span class="md-config-summary__value">{{ configForm.OrgID || '--' }}</span>
                            </div>
                            <div class="md-config-summary__item">
                                <span class="md-config-summary__label">APPID</span>
                                <span class="md-config-summary__value">{{ configForm.AppID || '--' }}</span>
                            </div>
                            <div class="md-config-summary__item">
                                <span class="md-config-summary__label">APPKey</span>
                                <span class="md-config-summary__value md-config-summary__value--secret">{{ configForm.AppKey ? '********' : '--' }}</span>
                            </div>
                            <div class="md-config-summary__item">
                                <span class="md-config-summary__label">OrgAuthKey</span>
                                <span class="md-config-summary__value md-config-summary__value--secret">{{ configForm.OrgAuthKey ? '********' : '--' }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 下方列表区：吃满右侧剩余高度。最后更新：2026-09-13 -->
                <el-card class="box-card md-list-card" shadow="hover">
                    <el-tabs v-model="activeTab" class="md-tabs" @tab-click="handleTabClick">
                        <el-tab-pane label="门禁设备列表" name="device">
                            <div class="table-toolbar premium-toolbar mb15">
                                <div class="left" style="display: flex; align-items: center;">
                                    <el-input v-model="searchKey" placeholder="搜索设备名称/SN" size="small" clearable
                                        class="fixed-search-box" style="width: 260px !important;"
                                        @keyup.enter.native="handleSearch">
                                    </el-input>
                                    <el-button type="primary" size="small" class="btn-search" icon="el-icon-search"
                                        @click="handleSearch" style="margin-left: 10px;">
                                        搜索
                                    </el-button>
                                </div>
                                <div class="right">
                                    <el-button type="success" size="mini" class="btn-sync" icon="el-icon-refresh"
                                        @click="syncDevices" :loading="syncLoading">
                                        同步魔点设备
                                    </el-button>
                                </div>
                            </div>
                            <div class="tbl-scroll-host">
                                <el-table :data="deviceList" v-loading="deviceLoading" stripe border size="small"
                                    height="100%" style="width: 100%;">
                                    <el-table-column prop="DeviceId" label="设备ID" width=""></el-table-column>
                                    <el-table-column prop="Sn" label="设备SN" width=""></el-table-column>
                                    <el-table-column prop="DeviceName" label="设备名称" min-width=""></el-table-column>
                                    <el-table-column prop="DeviceModel" label="设备型号" width=""></el-table-column>
                                    <el-table-column label="进出方向" width="" align="center">
                                        <template slot-scope="scope">
                                            <el-select v-model="scope.row.Direction" size="mini" placeholder="请选择"
                                                @change="handleDirectionChange(scope.row)">
                                                <el-option label="未设置" :value="0"></el-option>
                                                <el-option label="进" :value="1"></el-option>
                                                <el-option label="出" :value="2"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="pagination-container mt10" style="text-align: right;">
                                <el-pagination background @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange" :current-page="page"
                                    :page-sizes="[10, 20, 50]" :page-size="pageSize"
                                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                                </el-pagination>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="最近通行记录" name="record">
                            <div class="table-toolbar premium-toolbar mb15">
                                <div class="left" style="display: flex; align-items: center;">
                                    <el-input v-model="recordSearchKey" placeholder="成员ID / 设备ID / 设备SN" size="small"
                                        clearable class="fixed-search-box" style="width: 260px !important;"
                                        @keyup.enter.native="handleRecordSearch">
                                    </el-input>
                                    <el-button type="primary" size="small" class="btn-search" icon="el-icon-search"
                                        @click="handleRecordSearch" style="margin-left: 10px;">
                                        搜索
                                    </el-button>
                                </div>
                            </div>
                            <div class="tbl-scroll-host">
                                <el-table :data="recordList" v-loading="recordLoading" border stripe size="small"
                                    height="100%" style="width: 100%;">
                                    <el-table-column prop="RecognizeTime" label="识别时间" width="165" align="center">
                                        <template slot-scope="scope">
                                            {{ formatRecordTime(scope.row.RecognizeTime) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="StudentName" label="学生" min-width="100" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.StudentName">{{ scope.row.StudentName }}</span>
                                            <span v-else class="text-muted">未关联</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="MemberId" label="成员ID" min-width="120" show-overflow-tooltip />
                                    <el-table-column prop="DeviceName" label="设备名称" min-width="120" show-overflow-tooltip>
                                        <template slot-scope="scope">
                                            {{ scope.row.DeviceName || '--' }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="DeviceSn" label="设备SN" min-width="120" show-overflow-tooltip />
                                    <el-table-column prop="RecognizeType" label="识别类型" width="100" align="center" />
                                    <el-table-column prop="CreateTime" label="入库时间" width="165" align="center">
                                        <template slot-scope="scope">
                                            {{ formatRecordTime(scope.row.CreateTime) }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="pagination-container mt10" style="text-align: right;">
                                <el-pagination background @size-change="handleRecordSizeChange"
                                    @current-change="handleRecordCurrentChange" :current-page="recordPage"
                                    :page-sizes="[10, 20, 50]" :page-size="recordPageSize"
                                    layout="total, sizes, prev, pager, next, jumper" :total="recordTotal">
                                </el-pagination>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </template>

            <div v-else class="md-empty-wrap">
                <el-empty description="请先选择左侧部门/学校"></el-empty>
            </div>
        </section>
    </section>
</template>

<script>
import { getMoreDianConfig, saveMoreDianConfig, getMoreDianDevices, getMoreDianAccessRecords, syncMoreDianDevices, updateMoreDianDeviceDirection, registerMoreDianCallback } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import DepartmentPane from '@/components/DepartmentPane'

export default {
    name: "MoreDianManage",
    components: { DepartmentPane },
    data() {
        return {
            selectedDeptId: null,
            configForm: {
                AppID: "",
                AppKey: "",
                OrgID: "",
                OrgAuthKey: "",
                IsCallbackSync: false,
                CallbackUrl: ""
            },
            activeTab: "device",
            deviceList: [],
            recordList: [],
            recordLoading: false,
            recordPage: 1,
            recordPageSize: 10,
            recordTotal: 0,
            recordSearchKey: "",
            saveLoading: false,
            deviceLoading: false,
            syncLoading: false,
            showAppKey: false,
            showOrgAuthKey: false,
            // 分页与搜索
            page: 1,
            pageSize: 10,
            total: 0,
            searchKey: "",
            isEdit: false
        };
    },
    methods: {
        toggleEdit() {
            this.isEdit = true;
        },
        cancelEdit() {
            this.isEdit = false;
            this.loadConfig(); // 重置数据
        },
        treeNodeClick(data, node, component) {
            this.selectedDeptId = data.value;
            this.isEdit = false; // 切换学校时还原为只读模式
            this.loadConfig();
            if (this.activeTab === 'device') {
                this.fetchDevices();
            } else if (this.activeTab === 'record') {
                this.fetchAccessRecords();
            }
        },
        loadConfig() {
            if (!this.selectedDeptId) return;
            // 重置表单以防万一
            this.configForm = { AppID: "", AppKey: "", OrgID: "", OrgAuthKey: "" };

            getMoreDianConfig({ schoolId: this.selectedDeptId }).then(res => {
                if (res.success && res.response) {
                    this.configForm = res.response;
                }
            }).catch(() => {
                // 忽略错误
            });
        },
        saveConfig() {
            if (!this.selectedDeptId) return;
            this.saveLoading = true;
            saveMoreDianConfig({ schoolId: this.selectedDeptId }, this.configForm).then(res => {
                if (res.success) {
                    this.$message.success("保存成功");
                    this.isEdit = false;
                } else {
                    this.$message.error(res.msg || "保存失败");
                }
                this.saveLoading = false;
            }).catch(() => {
                this.saveLoading = false;
            });
        },
        fetchDevices() {
            if (!this.selectedDeptId) return;
            this.deviceLoading = true;
            const params = {
                schoolId: this.selectedDeptId,
                page: this.page,
                intPageSize: this.pageSize,
                key: this.searchKey
            };
            getMoreDianDevices(params).then(res => {
                if (res.success) {
                    this.deviceList = res.response.data || [];
                    this.total = res.response.dataCount || 0;
                } else {
                    this.$message.error(res.msg);
                }
                this.deviceLoading = false;
            }).catch(() => {
                this.deviceLoading = false;
            });
        },
        handleSearch() {
            this.page = 1;
            this.fetchDevices();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.fetchDevices();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.fetchDevices();
        },
        syncDevices() {
            if (!this.selectedDeptId) return;
            this.syncLoading = true;
            syncMoreDianDevices({ schoolId: this.selectedDeptId }).then(res => {
                if (res.success) {
                    this.$message.success("同步成功");
                    this.fetchDevices();
                } else {
                    this.$message.error(res.msg || "同步失败");
                }
                this.syncLoading = false;
            }).catch(() => {
                this.syncLoading = false;
            });
        },
        handleDirectionChange(row) {
            updateMoreDianDeviceDirection({ id: row.Id, direction: row.Direction }).then(res => {
                if (res.success) {
                    this.$message.success("设置方向成功");
                } else {
                    this.$message.error(res.msg || "设置方向失败");
                    this.fetchDevices(); // 还原状态
                }
            });
        },
        registerCallback() {
            const callbackUrl = `${BaseApiUrl}/api/MoreDian/Callback`;
            this.$confirm(`系统将自动注册回调地址：${callbackUrl}，是否确认？`, '注册推送', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                registerMoreDianCallback({ schoolId: this.selectedDeptId }).then(res => {
                    if (res.success) {
                        this.$message.success("注册成功");
                        this.loadConfig(); // 刷新回调状态
                    } else {
                        this.$message.error(res.msg || "注册失败");
                    }
                });
            });
        },
        handleTabClick(tab) {
            if (tab.name === 'device') {
                this.fetchDevices();
            } else if (tab.name === 'record') {
                this.fetchAccessRecords();
            }
        },
        /**
         * 分页拉取魔点通行记录
         */
        fetchAccessRecords() {
            if (!this.selectedDeptId) return;
            this.recordLoading = true;
            const params = {
                schoolId: this.selectedDeptId,
                page: this.recordPage,
                intPageSize: this.recordPageSize,
                key: this.recordSearchKey
            };
            getMoreDianAccessRecords(params).then(res => {
                if (res.success) {
                    this.recordList = res.response.data || [];
                    this.recordTotal = res.response.dataCount || 0;
                } else {
                    this.$message.error(res.msg || '加载通行记录失败');
                }
                this.recordLoading = false;
            }).catch(() => {
                this.recordLoading = false;
            });
        },
        handleRecordSearch() {
            this.recordPage = 1;
            this.fetchAccessRecords();
        },
        handleRecordSizeChange(val) {
            this.recordPageSize = val;
            this.fetchAccessRecords();
        },
        handleRecordCurrentChange(val) {
            this.recordPage = val;
            this.fetchAccessRecords();
        },
        formatRecordTime(val) {
            if (!val) return '--';
            const d = new Date(val);
            if (Number.isNaN(d.getTime())) return '--';
            const pad = n => (n < 10 ? '0' + n : '' + n);
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }
    }
};
</script>

<style scoped>
/* 整页铺满视口剩余高度，避免底部灰底空洞。最后更新：2026-09-13 */
.moredian-manage.dp-layout {
    height: 100%;
    max-height: 100%;
    min-height: 0;
    overflow: hidden;
}

.dp-left {
    overflow: hidden;
}

.dp-right {
    flex: 1;
    min-width: 0;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: transparent !important;
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
}

.mb20 {
    margin-bottom: 16px;
}

.mb10 {
    margin-bottom: 10px;
}

/* 魔点配置：紧凑面板，不参与拉伸 */
.md-config-panel {
    flex: 0 0 auto;
    margin-bottom: 12px;
    background: linear-gradient(180deg, #fbfcfe 0%, #ffffff 100%);
    border: 1px solid #e8edf3;
    border-radius: 12px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
    overflow: hidden;
}

/* 列表卡片：吃满配置区下方剩余高度 */
.md-list-card {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 0;
    border-radius: 12px;
}

.md-list-card >>> .el-card__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 12px 16px 14px;
}

.md-tabs {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.md-tabs >>> .el-tabs__header {
    flex-shrink: 0;
    margin-bottom: 12px;
}

.md-tabs >>> .el-tabs__content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.md-tabs >>> .el-tab-pane {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.md-tabs >>> .table-toolbar {
    flex: 0 0 auto;
}

.md-tabs >>> .tbl-scroll-host {
    flex: 1 1 auto;
    min-height: 0;
    height: 0;
    overflow: hidden;
}

.md-tabs >>> .pagination-container {
    flex: 0 0 auto;
}

.md-empty-wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e8edf3;
}

.md-config-panel__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 12px 16px;
    border-bottom: 1px solid #eef2f7;
}

.md-config-panel__title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
    font-size: 15px;
    font-weight: 600;
    color: #0f172a;
}

.md-config-panel__title i {
    color: var(--btn-primary, #2563eb);
}

.md-config-panel__callback {
    max-width: 320px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 400;
    color: #64748b;
}

.md-config-panel__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.md-config-panel__body {
    padding: 12px 16px 14px;
}

.md-config-panel__body--view {
    padding-top: 10px;
    padding-bottom: 12px;
}

.md-config-summary {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px 16px;
}

.md-config-summary__item {
    min-width: 0;
    padding: 8px 10px;
    background: #f8fafc;
    border: 1px solid #eef2f7;
    border-radius: 8px;
}

.md-config-summary__label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    color: #64748b;
    line-height: 1.2;
}

.md-config-summary__value {
    display: block;
    font-size: 13px;
    color: #1e293b;
    line-height: 1.4;
    word-break: break-all;
}

.md-config-summary__value--secret {
    letter-spacing: 1px;
    color: #94a3b8;
}

.md-config-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 0 16px;
}

.md-config-form >>> .el-form-item {
    margin-bottom: 0;
}

.md-config-form >>> .el-form-item__label {
    color: #64748b;
    font-weight: 500;
    line-height: 36px;
}

.md-config-form >>> .el-input__inner {
    border-radius: 8px;
}

.md-config-toggle {
    cursor: pointer;
    color: #94a3b8;
}

.md-config-toggle:hover {
    color: var(--btn-primary, #2563eb);
}

@media (max-width: 1200px) {
    .md-config-summary,
    .md-config-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .md-config-summary,
    .md-config-grid {
        grid-template-columns: 1fr;
    }

    .md-config-panel__head {
        flex-direction: column;
        align-items: stretch;
    }

    .md-config-panel__actions {
        justify-content: flex-end;
    }
}

/* 核心方案：通过样式模拟密码圆点，避开浏览器的 type="password" 启发式检测 */
.password-input /deep/ .el-input__inner {
    -webkit-text-security: disc !important;
}

.text-muted {
    color: #909399;
    font-size: 12px;
}

/* 高级工具栏样式 */
.premium-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #fcfcfd;
    border-radius: 12px;
    border: 1px solid #f0f0f5;
    margin-bottom: 20px;
}

.btn-sync {
    background: linear-gradient(135deg, #67c23a 0%, #4caf50 100%) !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(103, 194, 58, 0.2);
    border-radius: 8px !important;
    padding: 10px 20px !important;
    font-weight: 500;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn-sync:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(103, 194, 58, 0.3);
}

.btn-sync:active {
    transform: translateY(0);
}

.fixed-search-box {
    width: 260px !important;
    min-width: 260px !important;
    max-width: 260px !important;
    flex: none !important;
}

.fixed-search-box /deep/ .el-input__inner {
    border-radius: 4px !important;
    background-color: #ffffff !important;
    border: 1px solid #dcdfe6 !important;
    padding-left: 15px !important;
    width: 260px !important;
    /* 强制内部也固定 */
    transition: none !important;
    /* 彻底禁用任何过渡 */
}

.fixed-search-box /deep/ .el-input__inner:focus {
    border-color: var(--btn-primary, #2563eb) !important;
    width: 260px !important;
    /* 聚焦时也强制宽度 */
    box-shadow: none !important;
    /* 移除阴影防止错觉 */
}

.btn-search {
    border-radius: 4px !important;
    padding: 9px 15px !important;
}

.mb15 {
    margin-bottom: 15px;
}
</style>
